import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import CardEntrada from "./CardEntrada/CardEntrada"

const EntradasTab = ({ setOpenCadastro, idCentral }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [entradasList, setEntradasList] = useState(null)
    const [loading, setLoading] = useState(true)

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setEntradasList(msg.data.entradas)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    const handleSubmitOrdem = (msg) => {
        if (msg.data.status) {
            sendWs("buscarTodasEntradas", { condId: idCentral })
        } else {
            showNotify("error", "Não foi possível alterar a ordem das entradas!")
        }
    }

    useEffect(() => {
        setLoading(true)
        addRoute("buscarTodasEntradas", getDadosIniciais)
        addRoute("mudarOrdemEntrada", handleSubmitOrdem)
        sendWs("buscarTodasEntradas", { condId: idCentral })
    }, [])

    // const ItemTypes = {
    //     ENTRADA: 'Entrada'
    // }

    // const moveCard = (id, atIndex) => {
    //     const cardIndex = entradasList.findIndex(card => card.id === id)
    //     if (cardIndex === -1) {
    //         return
    //     }
    //     const card = entradasList[cardIndex]

    //     const newEntradasList = [...entradasList]
    //     newEntradasList.splice(cardIndex, 1)
    //     newEntradasList.splice(atIndex, 0, card)

    //     setEntradasList(newEntradasList)
    // }

    // const findCard = (id) => {
    //     const card = entradasList.filter((c) => `${c.id}` === id)[0]
    //     return {
    //         card,
    //         index: entradasList.indexOf(card)
    //     }
    // }
    // const [, drop] = useDrop({ accept: ItemTypes.ENTRADA })

    return (
        // <EntradasContext.Provider value={{ }}>
        <div style={{ height: '100%', width: '100%' }}>

            {(!loading && entradasList) &&
                entradasList.map((entrada, index) => {
                    return (
                        <CardEntrada
                            key={index}
                            id={entrada.id}
                            index={index}
                            entrada={entrada}
                            idCentral={idCentral}
                            // moveCard={moveCard}
                            // findCard={findCard}
                        />
                    )
                })
            }
        </div>
        // </EntradasContext.Provider>
    )
}

export default EntradasTab
